import { useEffect, useRef, useState } from "react";
import { ChevronDown } from "lucide-react";

function SelectButton(props) {

const {options,title,passKey,handleClick} =props

  const [showAddMenu, setShowAddMenu] = useState(false);

  const menuRef = useRef(null);

  // Close on outside click
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target)
      ) {
        setShowAddMenu(false);
      }
    };

    document.addEventListener(
      "mousedown",
      handleOutsideClick
    );

    return () => {
      document.removeEventListener(
        "mousedown",
        handleOutsideClick
      );
    };
  }, []);

  return (
    <div
      className="add-q-split-wrapper"
      ref={menuRef}
      style={{ position: "relative" }}
    >
      <div
        className="add-q-split-btn btn btn-primary"
        onClick={() => setShowAddMenu((v) => !v)}
        style={{ cursor: "pointer" }}
      >
        <span className="add-q-split-label">
          {title}
        </span>

        <button className="add-q-chevron-btn">
          <ChevronDown size={14} />
        </button>
      </div>

      {showAddMenu && (
        <div className="add-q-menu">
            {
                options?.map((opt,index)=>{
                    return <button
                    className="add-q-menu-item"
                    onClick={() =>{ 
                        handleClick(opt?.[passKey],opt)
                        setShowAddMenu(false)
                    }}
                  >
                    <img src={opt?.icon} alt="icon" style={{height:"14px",width:'14px'}} />
                    {opt?.title}
                  </button>
                })
            }
          
        </div>
      )}
    </div>
  );
}

export default SelectButton;